import React, { useCallback, useState } from 'react';
import { Button, Container, Stack } from 'react-bootstrap';
import Select from 'react-select';
import { useParams } from 'react-router-dom';
import { useIsAdmin, useIsCreator } from '../../hooks/user';
import LayerModal from '../Modals/PromoModal';
import PromoModal from '../Modals/PromoModal';

const PromosFilter = ({ count, onChange }) => {
  const [showCreatePromoModal, setShowCreatePromoModal] = useState(false);
  const { userName } = useParams();

  const isAdmin = useIsAdmin(userName);
  const isCreator = useIsCreator(userName);

  const handleChange = useCallback(
    (e) => {
      onChange(e.value);
    },
    [onChange],
  );

  const filters = [{ value: 'list', label: 'List View' }];

  const styles = {
    menu: (provided) => ({
      ...provided,
      width: 'max-content',
      zIndex: 200,
      minWidth: '160px',
    }),
  };

  return (
    <>
      <Container fluid className="filter-sort-bar">
        <Stack
          direction="horizontal"
          gap={3}
          className="align-items-center justify-content-between"
        >
          <h2 className="h6 mb-0">{`${count || 'No'} items`} </h2>

          <Stack direction="horizontal" gap={3} className="align-items-center">
            <div style={{ minWidth: '160px' }}>
              <Select
                menuPlacement="auto"
                options={filters}
                defaultValue={filters[0]}
                onChange={handleChange}
                styles={styles}
              />
            </div>
            {isAdmin || isCreator ? (
              <Button
                variant="secondary"
                onClick={() => setShowCreatePromoModal(true)}
              >
                New Promo
              </Button>
            ) : null}
          </Stack>
        </Stack>
      </Container>

      {showCreatePromoModal && (
        <PromoModal
          data={{}} // TODO: Improve this.. I don't like it
          onHideModal={() => setShowCreatePromoModal(false)}
        />
      )}
    </>
  );
};

export default PromosFilter;
